import { render, staticRenderFns } from "./UsersAndPermissibles.vue?vue&type=template&id=0ce27198&scoped=true&"
import script from "./UsersAndPermissibles.vue?vue&type=script&async=true&lang=js&"
export * from "./UsersAndPermissibles.vue?vue&type=script&async=true&lang=js&"
import style0 from "./UsersAndPermissibles.vue?vue&type=style&index=0&id=0ce27198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce27198",
  null
  
)

export default component.exports